import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { ENV, isSupabaseConfigured } from '@/lib/constants';

// Single browser Supabase client. Uses the PUBLISHABLE (anon) key only — every
// read/write it performs is bound by Row Level Security. Anything that must cross
// a user boundary (order sync, audit, staff lists) goes through the BFF with the
// service-role key, never from here.
export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(ENV.supabaseUrl, ENV.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

/** Current access token (JWT) for authenticating BFF calls, or null for guests. */
export async function getAccessToken(): Promise<string | null> {
  if (!supabase) return null;
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}

export { isSupabaseConfigured };
